import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from 'app/components/ui/alert-dialog';
import { toast } from 'sonner';
import { useCourseSlice } from '../../slice';
import { useEffect } from 'react';

interface Props {
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
  data: any;
}

export function AlertProductCategoriesDelete({
  isOpen,
  onOpenChange,
  data,
}: Props) {
  const { useDeleteCourseCategoriesMutation } = useCourseSlice();

  const [
    deleteCategories,
    { isLoading: isDeleting, error: deleteError, data: deletedData },
  ] = useDeleteCourseCategoriesMutation();
  const handleDelete = () => {
    deleteCategories(data.category_id);
  };

  useEffect(() => {
    if (deleteError) {
      toast.error(deleteError?.message || 'An error occurred');
    }
  }, [deleteError]);

  useEffect(() => {
    if (deletedData) {
      toast.success(deletedData?.message || 'Tag deleted successfully');
      onOpenChange(false);
    }
  }, [deletedData]);

  return (
    <AlertDialog open={isOpen} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Are you absolutely sure?</AlertDialogTitle>
          <AlertDialogDescription>
            This action cannot be undone.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={handleDelete} disabled={isDeleting}>
            Continue
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
